import { cn } from "@omni/utils/styles";
import { identity } from "lodash-es";
import { MouseEvent } from "react";

import { EnergyLabelModal } from "@/components/Modals/EnergyLabelModal/energyLabelModal";
import { useEnergyLabelContext } from "@/components/Product/energyLabel/context/energyLabel.context";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

type Props = {
    discriminator?: string;
    className?: string;
};

export const LabelNested = ({ discriminator, className }: Props) => {
    const { t } = useGranite();

    const energyLabel = useEnergyLabelContext();
    const eprelId = energyLabel.eprel ? energyLabel.eprelId : undefined;

    const modal = energyLabel.eprel || !!energyLabel.label;
    const modalDiscriminator = [discriminator, eprelId]
        .filter(identity)
        .join("-");

    const { open: openModal } = useModalRouter(
        ModalType.EnergyLabel,
        modalDiscriminator
    );

    const handleOnDetailClick = (event: MouseEvent) => {
        if (!modal) return;

        event.preventDefault();

        openModal();
    };

    return (
        <>
            <img
                className={cn(
                    "tw:h-auto tw:w-14",
                    {
                        "tw:hover:cursor-pointer": modal
                    },
                    className
                )}
                src={energyLabel.labelNested}
                alt={t("product.energyLabel.altText")}
                onClick={handleOnDetailClick}
            />
            {modal && <EnergyLabelModal discriminator={modalDiscriminator} />}
        </>
    );
};
